module.exports = __webpack_public_path__ + "img/perfectly-grilled-salmon.4c866507.png";